// extracted by mini-css-extract-plugin
export default {"panel":"CommitGroup-module__panel--Agk7V"};